import { AuthEnvironment } from "./backend/interfaces/IAuthenticationProvider";

export const RETRY_SETTINGS = {
    maxRetries: 3,
    retryWaitMilliseconds: 5000
};

// Defined in webpack.config.js
declare const __APP_VERSION__: string;
declare const __APP_INTERNAL_NAME__: string;
declare const __IS_DEV_BUILD__: boolean;

export const APP_VERSION = __APP_VERSION__;
export const APP_INTERNAL_NAME = __APP_INTERNAL_NAME__;
export const IS_DEV_BUILD = __IS_DEV_BUILD__;

export const TELEMETRY_EVENT_AGGREGATION_TIME_INTERVAL_MILLISECONDS = 60000;
export const MAX_UNRESPONSIVENESS_WAIT_TIME_MILLISECONDS = 60000;
export const MAX_BOOT_TIME_MILLISECONDS = 60000;
export const AUTH_ENVIRONMENT_DEFAULT: AuthEnvironment = AuthEnvironment.Prod;
export const ENABLE_FILE_UPLOAD: boolean = true;
export const ENABLE_DIARIZATION: boolean = true;
export const ENABLE_FAST_FILE_UPLOAD: boolean = false;

const DEV_SSO_LOGIN_URL: string = "https://fa000000051.resources.office.net:3000/login.html";
const PROD_SSO_LOGIN_URL: string = "https://fa000000051.resources.office.net/f7024bdc-7caf-4ca8-807d-2908f09640d6/1.1.2006.3005/en-us_web/login.html";
export const SSO_LOGIN_URL: string = IS_DEV_BUILD ? DEV_SSO_LOGIN_URL : PROD_SSO_LOGIN_URL;

export const LOG_AUGLOOP_RUNTIME_EVENTS_TO_CONSOLE_BROWSER_ENABLED: boolean = IS_DEV_BUILD;
export const LEARN_MORE_URL: string = "https://support.office.com/article/7fc2efec-245e-45f0-b053-2a97531ecf57";
export const DEV_AUGLOOP_URL: string = "https://augloop.office.com";

export const ACCEPTED_FILE_FORMATS_FOR_UPLOAD = ".wav, .mp4, .m4a, .mp3";

export const AVAILABLE_UPLOAD_MINUTES_PER_MONTH = 300;